import { Autocomplete, TextField } from "@mui/material";
import { memo, useEffect, useState } from "react";
import CentroDistribuicao from "../classes/CentroDistribuicao";
import CentroDataset from "../data/CentroDataset";
import { useGridApiContext } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";

function AutocompleteCentroMateriaPrima(props: any) {
    const { t } = useTranslation();
    const { id, value, field } = props;
    const apiRef = useGridApiContext();
    const dataSet = new CentroDataset();
    const [data, setData] = useState<CentroDistribuicao[]>([]);
    const [dataFilter, setDataFilter] = useState<CentroDistribuicao[]>([]);
    const [autoCompleteValue, setAutoCompleteValue] = useState<string | undefined>("");
    const [autoCompleteInputValue, setAutoCompleteInputValue] = useState("");

    useEffect(() => {
        if (dataSet.hasCache()) {
            const centrosCache: CentroDistribuicao[] = dataSet.ListarFromCache();
            if (centrosCache) {
                setData(centrosCache);
                setAutoCompleteData(centrosCache);
            }
        } else {
            dataSet.ListarAtivos().then((result) => {
            setData(result);
            setAutoCompleteData(result);
            dataSet.AdicionarListaAoCache(result);
            });
        }
    
        function setAutoCompleteData(data: CentroDistribuicao[]) {
          if (data && id && field) {
            const row = apiRef.current.getRow(id);
            if (row) {
                let tempCentro: String | null = null;
                if (field === 'centroDescricao') {
                    tempCentro = row.centro;
                }
                if (tempCentro) {
                    const centroFound: CentroDistribuicao | undefined = data.find((f) => f.centro === tempCentro);
                    
                    if (centroFound) {
                    setAutoCompleteValue(
                        String(centroFound.centro) + " - " + centroFound.nome
                    );
                }
              }
            }
          }
        }
      }, []);

    useEffect(() => {
        if (dataFilter) {
            if (dataFilter.length === 1) {
                localStorage.setItem("centroMP", String(dataFilter[0].centro));
            } else if (dataFilter.length !== 1) {
                localStorage.removeItem("centroMP");
            }
        }
    }, [dataFilter]);

    useEffect(() => {
        if (dataFilter !== null && dataFilter !== undefined && dataFilter.length === 1) {
            const cellValue = {
                id,
                field,
                value: String(dataFilter[0].centro),
            };
          if (cellValue.field === "centroDescricao") {
            cellValue.field = "centro";
          }
          apiRef.current.setEditCellValue(cellValue);
          apiRef.current.commitCellChange(cellValue);
        }
      }, [dataFilter]);

    const handlerOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setDataFilter(data.filter(f => f.centro.toString().startsWith(event.target.value)))
    }

    const handlerAutocompleteOnChange = (
        event: React.SyntheticEvent<Element, Event>,
        _newValue: string | undefined
      ) => {
        setDataFilter(
          data.filter(
            (f) =>
              f.centro.toString() + " - " + f.nome ===
              String(event.currentTarget.textContent)
          )
        );
      };

    return (
        <>
          <Autocomplete
            value={autoCompleteValue}
            inputValue={autoCompleteInputValue}
            onInputChange={(_event, newInputValue) => {
              setAutoCompleteInputValue(newInputValue);
            }}
            fullWidth
            size="small"
            freeSolo
            id="autoCompleteCentroMateriaPrima"
            disableClearable
            options={data.map(
              (option: any) => option.centro + " - " + option.nome
            )}
            onChange={handlerAutocompleteOnChange}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t("common.autoComplete.centro.label")}
                InputProps={{
                  ...params.InputProps,
                  type: "search",
                }}
                onChange={handlerOnChange}
              />
            )}
          />
        </>
    );
}

export default memo(AutocompleteCentroMateriaPrima);